import styled, { keyframes } from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_SETTINGS_CONTENT_ENTER_DURATION_S,
  DRAWER_SETTINGS_CONTENT_ENTER_OFFSET_PX,
  IStyledAttributes,
} from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
} from "@ryde/theme";

const settingsContentEnter = keyframes`
  from {
    opacity: 0;
    transform: translateY(-${DRAWER_SETTINGS_CONTENT_ENTER_OFFSET_PX}px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SettingsGroupContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "settings-group-container",
  },
)`
  margin-top: 3px;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  padding-inline-start: 16px;
`;

export const SettingsGroupHeaderStyled = styled.button.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "settings-group-header",
  },
)`
  background-color: ${greyMui._100};
  color: ${blueGreyMui._500};
  width: 100%;
  height: 32px;
  padding-inline-end: 12px;
  padding-inline-start: 12px;
  margin-top: 2px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  border: none;
  text-align: start;

  &:focus-visible {
    outline: 2px solid ${deepPurpleMui.A400};
    outline-offset: 2px;
  }

  .collapse_toggle {
    margin-inline-start: auto;
  }
`;
export const SettingItemStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "settings-item",
})`
  height: 32px;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline-end: 12px;
  padding-inline-start: 12px;
  font-weight: 400;
  border-radius: 6px;
  color: ${rydeColors.black};
  width: 100%;

  a {
    color: inherit;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }

  label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .item_icon {
    display: none;
    align-items: center;
    margin-inline-end: 8px;
    flex-shrink: 0;
  }

  .settings-menu-feedback-icon {
    width: 16px;
    height: 16px;
  }

  .arrow_item {
    display: none;
    cursor: pointer;
    margin-inline-start: auto;
  }
  &:focus-visible {
    outline: 2px solid ${deepPurpleMui.A400};
    outline-offset: 2px;
  }
  &:hover {
    transition: font-weight 150ms ease-in;
    color: ${deepPurpleMui.A400};
    background-color: rgba(179 136 255/ 0.2);
    font-weight: 600;
    .arrow_item {
      display: inline-block;
    }
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    .item_icon {
      display: inline-flex;
    }

    .active {
      font-weight: 900;
    }
  }
`;

export const SettingsContainerStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "settings-container",
})`
  margin-top: 5px;
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-bottom: 35px;
    margin-bottom: 20px;
  }
`;

export const SettingsEnterContentStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "settings-enter-content",
})`
  @media (prefers-reduced-motion: no-preference) {
    animation: ${settingsContentEnter}
      ${DRAWER_SETTINGS_CONTENT_ENTER_DURATION_S}s ease-out both;
  }
`;
